// extracted by mini-css-extract-plugin
export default {"modal":"IT-z","error":"JT-z","disabled":"KT-z","fields":"LT-z","errorMsg":"MT-z","footer":"NT-z","formContentWrapper":"OT-z","productImage":"PT-z","overlay":"QT-z"};